<template>
  <v-content column class="side_area scrollableEventOverview">
    <h2>{{ $translate("EVENT_OVERVIEW") }}</h2>
    <v-layout row wrap>
      <v-flex xs12 class="px4">
        <v-autocomplete
          v-model="searchTextNew"
          :items="internalEvents"
          :loading="isLoading"
          :search-input.sync="searchEventString"
          hide-no-data
          hide-selected
          item-text="Name"
          item-value="EventId"
          :label="$translate('SEARCH')"
          clearable
          :placeholder="$translate('START_TYPING')"
          return-object
          @change="autocompleteEventChange"
        ></v-autocomplete>
        <!-- <h3>{{$translate('TAGS_CATEGORIES')}}</h3> -->
        <!-- <CategoriesTree
          id="categoryForEventsOverview"
          :categoriesAll="eventCategoriesAll"
          v-on:categoriesSelected="setSelectedEventCategories"
          class="mt-4 mb-4"
          :style="`border: 1px solid black; border-radius: 5px`"
        ></CategoriesTree> -->
        <h3 class="mt-2">{{ $translate("EVENT_FILTERTYPE") }}</h3>
        <v-layout row wrap class="filterOptions">
          <v-select multiple chips v-model="filterType" :items="typeFilters">
          </v-select>
        </v-layout>
        <v-flex align-center>
          <v-layout class="ml-1 mr-1 mt-2">
            <v-flex>
              <v-tooltip bottom>
                <v-btn
                  color="secondary"
                  slot="activator"
                  class="text-capitalize"
                  round
                  @click="createNewEvent"
                  block
                  :loading="loadingButton"
                >
                  {{ $translate("CREATE_EVENT") }}
                  <span slot="loader" class="custom-loader">
                    <v-icon light>cached</v-icon>
                  </span>
                </v-btn>
                <span>{{ $translate("CREATE_EVENT") }}</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-dialog v-model="deleteDialog" persistent max-width="290">
          <v-card class="generic_dialog_class">
            <v-progress-linear
              v-if="showProgress"
              :indeterminate="true"
              color="blue"
            ></v-progress-linear>
            <v-card-title
              class="headline"
              :style="`color: ${$vuetify.theme.primary}`"
              >{{ $translate("EVENT_DELETION") }}</v-card-title
            >
            <v-card-text>{{ deleteText }}</v-card-text>
            <v-card-text>{{ this.itemToBeDeleted.name }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                round
                class="text-capitalize"
                @click.native="deleteDialog = false"
                >{{ $translate("CANCEL") }}</v-btn
              >
              <v-btn
                color="primary"
                round
                class="text-capitalize"
                :loading="loadingConfirmation"
                :disabled="disableUpdate"
                @click.native="deleteEvent"
                >{{ $translate("DELETE") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import * as dssRequest from "@/api/dssRequest";
import CreateEventObject2 from "@/objects/CreateEventObject2.js";
import appConfig from "../../config/app_config";
import BatchGroupObject from "@/objects/BatchGroupObject.js";
import { mapGetters } from "vuex";
import BaseObject from "@/objects/BaseObject";
import EntityList from "@/components/EntityList";
import BaseComponent from "@/components/base/BaseComponent";
import { ui_helpers } from "../shared/ui_helpers";
import ExpendableTags from "@/components/ExpendableTags";
import CategoriesTree from "@/components/CategoriesTree";

export default {
  name: "EventView_Overview",
  extends: BaseComponent,
  mixins: [ui_helpers],
  props: {
    properties: Object,
  },
  computed: {
    ...mapGetters({
      _getEvents: "getEvents",
    }),
  },
  watch: {
    searchEventString: function (e, prev) {
      console.log(" prev e", e, prev);
      // if(prev !== null && e === null){
      //   this.searchEventString = "";
      // }
      this.$store.commit("setEventFilterName", this.searchEventString);
      if (e !== prev && prev !== null && e !== null) {
        this.isLoading = true;
        this.getEventsInternally();
      }
    },
    filterType: function (newV, oldV) {
      if (newV.length == 0) {
        this.objectOfTypes = {};
        this.sendSignalToGetEvents();
      } else {
        let data = {};
        newV.forEach(function (value, index) {
          data[value] = value;
        });
        this.objectOfTypes = data;
        this.sendSignalToGetEvents();
      }
    },
    _getEvents: function (newE, oldE) {
      this._getEvents.forEach((element) => {
        element.selected = false;
      });
    },
    properties: {
      handler(value) {
        if (
          value.params != undefined &&
          value.params.select != undefined &&
          !isNaN(value.params.select)
        )
          this.selectEvent({ eventId: value.params.select });
      },
      deep: true,
    },
  },
  components: {
    EntityList,
    ExpendableTags,
    CategoriesTree,
  },
  data() {
    return {
      doNotSaveOnType: false,
      loadingConfirmation: false,
      disableUpdate: true,
      deleteText: "",
      disableExpTag: false,
      expTagProp: {},
      loadingButton: false,
      searchText: "",
      searchTextNew: {},
      internalEvents: [],
      isLoading: false,
      searchEventString: "",
      itemToBeDeleted: {},
      showProgress: false,
      deleteDialog: false,
      filterMenu: false,
      current_date: null,
      eventDetail: {},
      typeFilters: [
        "Theme",
        "Main",
        "Standard",
        "Relay",
        "Tour",
        "FlexEvent",
        "Fixed",
        "Promotion",
        "PartnerPromotion",
        "Repetitive",
        "Rental",
        "OrderEvent",
        "External",
        "Webshop",
        "Delivery",
        "PickUp",
      ],
      filterType: [],
      tagsFilters: {},
      objectOfTypes: {},
      eventCategoriesAll: [],
      eventCategoriesSelected: [],
    };
  },
  created() {
    window.EventBus.listen("selectEvent", this.selectEvent);
    window.EventBus.listen("showDeleteEvent", this.showDeleteEvent);
  },
  beforeDestroy() {
    this._getEvents.forEach((e, index) => {
      this.$set(e, "selected", false);
    });
    window.EventBus.removeListener("selectEvent", this.selectEvent);
    window.EventBus.removeListener("showDeleteEvent", this.showDeleteEvent);
  },
  methods: {
    sortEvents() {
      console.log("this.locations", this.locations);
      this.locations.sort((a, b) =>
        a.name.localeCompare("x", "en-US", {
          sensitivity: "base",
        })
      );
      this.sort = !this.sort;
      this.$store.commit("setSortLocationOrder", this.sort);
    },
    autocompleteEventChange(event) {
      console.log(" event ?! event i guess.", event);
      this.$store.commit(
        "setEventFilterName",
        event != undefined ? event.Name : ""
      );
      window.EventBus.fire("getEventsBasedOnUserLevel");
    },
    getEventsInternally() {
      console.log(" ME LOOPPIE?");
      const payload = {
        FunctionId: "EventFunctionLibrary::getEventsBasedOnUserLevel",
        UserLevel: this.$store.getters["auth/userLevel"],
        PartnerId: this.$store.getters["auth/partnerId"],
        Filters: {
          LocationId: "",
          Tags: {},
          Type: {},
          Name: this.searchEventString,
        },
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getEventsBasedOnUserLevel was successful",
            response
          );
          if (response.data.Events !== undefined) {
            this.internalEvents = BaseObject._createArrayWithObjects(
              response.data.Events
            );
          }
          this.isLoading = false;
        },
        (error) => {
          console.log(
            "The generic call getEventsBasedOnUserLevel was not successful",
            error
          );
          this.isLoading = false;
        },
        "communicateWithDBLibrary",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },
    showDeleteEvent({ item: item, text: text, disable: disable }) {
      console.log(" CALLED YES!", item, text, disable);
      this.deleteDialog = true;
      this.itemToBeDeleted = item;
      this.deleteText = text;
      this.loadingConfirmation = false;
      this.disableUpdate = disable;
    },

    deleteEvent() {
      this.disableUpdate = true;
      this.loadingConfirmation = true;

      const payload = {
        EventId: Number(this.itemToBeDeleted.eventId),
        PartnerId: Number(this.$store.getters["auth/partnerId"]),
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The call deleteEvent was successful", response);
          this.sendSignalToGetEvents();
          window.EventBus.fire("dataForComponent", {});
          this.deleteDialog = false;
        },
        (error) => {
          console.log("The call deleteEvent was not successful", error);
          setTimeout(() => {
            this.deleteDialog = false;
          }, 2000);
        },
        "deleteEvent",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    showSelectedTags(filters) {
      this.tagsFilters = {};
      if (filters.length == 0) filters = null;
      for (const [key, value] of Object.entries(filters)) {
        if (!_.isEmpty(value)) {
          for (const [innerKey, innerValue] of Object.entries(value)) {
            this.tagsFilters[innerKey] = innerValue;
          }
        }
      }
      this.sendSignalToGetEvents();
    },
    createNewEvent() {
      this.selectEvent("none");
      // if (this.$store.getters["auth/userLevel"] == 6) {
      // this.showComponents({
      //   main: "Events_main",
      //   side: "EventView_Overview"
      // });
      // setTimeout(()=> {
      //   window.EventBus.fire("TypeOfEventCreationTrigger");
      // }, 300);
      //
      // } else {
      this.showComponents({
        main: "EventCreation",
        side: "EventView_Overview",
      });
      // }
      window.EventBus.fire("dataForComponent", {});
    },
    sendSignalToGetEvents() {
      // Checks if filters are active - fires a signal to retrieve the events based on user level
      let toSetFilters = {};
      if (!_.isEmpty(this.tagsFilters)) toSetFilters.Tags = this.tagsFilters;
      if (!_.isEmpty(this.objectOfTypes))
        toSetFilters.Type = this.objectOfTypes;
      if (this.eventCategoriesSelected.length > 0) {
        toSetFilters.Categories = this.eventCategoriesSelected;
      }
      this.$store.commit("setFiltersForEvent", toSetFilters);

      window.EventBus.fire("getEventsBasedOnUserLevel", toSetFilters);
    },
    selectEvent(item) {
      if (item == "none") {
        this._getEvents.forEach((e, index) => {
          this.$set(e, "selected", false);
        });
        return;
      }
      this._getEvents.forEach((e, index) => {
        let v = true;
        if (e.eventId != item.eventId) {
          v = false;
        }
        this.$set(e, "selected", v);
      });

      window.EventBus.fire("dataForComponent", {});
      this.showComponents({
        main: "Events_main",
        side: "EventView_Overview",
      });

      const payload = {
        FullPicture: true,
        EventId: Number(item.eventId),
        LanguageTagId: this.$store.getters.getUserLanguage,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getEventDetails", response);
          this.eventDetail = CreateEventObject2._createArrayWithObjects(
            response.data
          );
          // this.eventDetail.main = Number(this.eventDetail.main);

          window.EventBus.fire("dataForComponent", this.eventDetail);
        },
        (error) => {
          console.log(
            "The generic call getEventDetails was not successful",
            error
          );
          this.eventDetail = BaseObject._toLowerCaseObjectProperties(
            error.data
          );
          window.EventBus.fire("dataForComponent", this.eventDetail);
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getEventCategories() {
      // Not used now
      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getInterestsForEvent] on [LocationsNode_ISE] in component [EventView_Overview] succeeded",
            response
          );
          this.eventCategoriesAll = [];
          if (
            response.data.hasOwnProperty("Interests") &&
            response.data.Interests !== undefined
          ) {
            this.eventCategoriesAll = [...response.data.Interests];
          }
        },
        (error) => {
          console.log(
            "The call [getInterestsForEvent] on [LocationsNode_ISE] in component [EventView_Overview] failed",
            error
          );
        },
        "getInterestsForEvent",
        "LocationsNode_ISE",
        payload
      );
    },
    setSelectedEventCategories(categoriesSelected) {
      this.eventCategoriesSelected = [];
      this.eventCategoriesSelected = [...categoriesSelected];
      this.sendSignalToGetEvents();
    },
  },
};
</script>

<style lang="scss" scoped="">
.scrollable {
  height: 50vh;
  padding-bottom: 1em;
  overflow-x: hidden;
  overflow-y: auto;
}
.bl {
  font-size: 29px !important;
}
.v-btn-2 {
  min-width: 1em;
}
.dialogAddEvent {
  max-width: 100%;
  overflow-y: hidden;
}
#plb {
  padding-top: 5px;
  padding-left: 10px;
}
.tileDetail {
  border-bottom: 2px solid grey;
}
.marginTop {
  margin-top: 100px !important;
}

.dialogButton {
  width: 100% !important;
  margin: 0px 0px 25px 0px;
}
.listOutline {
  border-bottom: 2px #999999 solid;
  /*  background-color: #f2f2f2;*/
  padding-top: 2px;
}
.listHeader {
  outline: 2px #999999 solid;
  /*  background-color:#dddddd;*/
}
.listItem {
  border-bottom: 2px #999999 solid;
  /*  background-color:#f2f2f2;*/
}

.highlighted_event {
  background-color: #f2f2f2;
}

@media only screen and (min-width: 960px) {
  .paddingLeft {
    padding-left: 25px;
  }
  .paddingRight {
    padding-right: 25px;
  }
}
.scrollList {
  width: 100%;
  max-height: calc(61vh) !important;
  overflow-x: hidden;
  overflow-y: auto;
}
@media only screen and (min-width: 960px) {
  .paddingLeft {
    padding-left: 25px;
  }
  .paddingRight {
    padding-right: 25px;
  }
}
.bottomLine {
  height: 100px !important;
  padding-bottom: 9px;
  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  border: solid 2px #757575;
  border-radius: 3px;
}

.category_style {
  border-radius: 1em;
}

.scrollableEventOverview {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 49em;
}
.filterOptions {
  margin-top: -1em;
}
</style>

